import type { NotificationCategory } from "prisma-internal";

export const NOTIFICATION_CATEGORIES: {
  [K in NotificationCategory]: { label: string; value: K };
} & {
  all: { label: string; value: "all" };
} = {
  all: { label: "すべて", value: "all" },
  notice: { label: "お知らせ", value: "notice" },
  application: { label: "各種申請", value: "application" },
  health_checkup: { label: "健康診断", value: "health_checkup" },
};
